import styled from "styled-components";

export const BaseDivHomePage = styled.div`
	width: 100%;
	max-width: 1200px;
	padding: 0 2rem;
	margin: 0 auto;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		padding: 0 1rem;
	}
`;
export const Container = styled.div`
	position: relative;
	background: ${({ theme }) => theme.pantoneBlack};

	color: ${({ theme }) => theme.white};
	min-height: 100vh;
`;

export const Content = styled.div`
	overflow: hidden;
`;
